export default function BusinessPerspective() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-black text-gray-900 mb-6">
            超重要な<strong className="text-primary">経営的視点</strong>
          </h2>
        </div>
        
        <div className="max-w-4xl mx-auto space-y-12">
          <div className="bg-gradient-to-br from-primary to-primary-dark text-white rounded-2xl p-12 shadow-lg">
            <h3 className="text-3xl font-bold mb-6">Amazon自動化の本質は：</h3>
            <p className="text-2xl font-bold leading-relaxed">
              「作業を減らす」ではなく<br />
              「競争力のある状態を維持する」
            </p>
          </div>
          
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-8">Amazonの特徴：</h3>
            <div className="space-y-6">
              <div className="flex items-start gap-4 bg-red-50 border-2 border-red-200 rounded-xl p-6">
                <i className="ri-time-line text-3xl text-red-600 mt-1"></i>
                <div>
                  <p className="text-xl font-bold text-gray-900">放置すると順位が下がる</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4 bg-orange-50 border-2 border-orange-200 rounded-xl p-6">
                <i className="ri-user-line text-3xl text-orange-600 mt-1"></i>
                <div>
                  <p className="text-xl font-bold text-gray-900">人力では判断が遅れる</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4 bg-yellow-50 border-2 border-yellow-200 rounded-xl p-6">
                <i className="ri-emotion-sad-line text-3xl text-yellow-600 mt-1"></i>
                <div>
                  <p className="text-xl font-bold text-gray-900">感覚的な運用では競争に勝てない</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="bg-white border-2 border-primary rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">だから自動化は：</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-primary/5 rounded-xl p-6 text-center">
                <i className="ri-shield-check-line text-5xl text-primary mb-4"></i>
                <p className="text-xl font-bold text-gray-900">"防衛戦略"</p>
              </div>
              <div className="bg-primary/5 rounded-xl p-6 text-center">
                <i className="ri-sword-line text-5xl text-primary mb-4"></i>
                <p className="text-xl font-bold text-gray-900">"攻撃戦略"</p>
              </div>
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold mb-6">多くの事業者の課題</h3>
            <div className="space-y-6">
              <div className="bg-white/10 rounded-xl p-6">
                <p className="text-lg mb-2">多くの事業者が求めているのは：</p>
                <p className="text-xl font-bold">「Amazonで楽に運営したい」</p>
              </div>
              
              <div className="flex items-center justify-center">
                <i className="ri-arrow-down-line text-4xl"></i>
              </div>
              
              <div className="bg-primary rounded-xl p-6">
                <p className="text-lg mb-2">しかし実際には：</p>
                <p className="text-xl font-bold leading-relaxed">
                  「Amazonは継続的な最適化が必要な市場。<br />
                  競争力を保つには自動化が効果的です。」
                </p>
              </div>
            </div>
            
            <div className="mt-8 bg-white/10 rounded-xl p-6">
              <p className="text-lg">
                この重要性を理解している経営者ほど、<br />
                <strong className="text-2xl">継続的な運用支援を求めています。</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
